import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  formGroup: {
    marginBottom: theme.spacing(3)
  },
}));

const ParkingDescription = props => {
  const { className, parkingInfos, handleFieldChange, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Parking Description" />
      <CardContent>
        <div className={classes.formGroup}>
          <TextField
            fullWidth
            label="Parking Description"
            name="description"
            onChange={event =>
              handleFieldChange(event, 'description', event.target.value)
            }
            value={parkingInfos.description}
            multiline={true}
            rows={20}
            variant="outlined"
            required
          />
        </div>
      </CardContent>
    </Card>
  );
};

ParkingDescription.propTypes = {
  parkingInfos: PropTypes.object,
  handleFieldChange: PropTypes.func,
  className: PropTypes.string
};

export default ParkingDescription;
